'use client';
import { memoize, strategyVariadic } from '@s7/memo';

function memoizedEmitter(emitter) {
    return memoize(emitter, {
        /*
         * Хэш темы создаётся при создании объекта темы с помощью mergeTheme.
         * Кастомный сериализатор требуется для обеспечения эффективности по памяти.
         * */ serializer: function serializer(param) {
            var theme = param[0], others = param.slice(1);
            return theme.__hash + JSON.stringify(others);
        },
        strategy: strategyVariadic
    });
}

export { memoizedEmitter };
